import * as React from "react"

export const UserProfilePage = () => (
    <p>UserProfilePage</p>
)
